<template>
  <div>
    <router-link
      v-for="job in jobs"
      :key="job.id"
      v-slot="{ navigate, isActive }"
      :to="{
        name: 'Homecare',
        params: { projectId: $route.params.projectId, jobId: job.job_order_id },
        query: { home_id: job.home_id },
      }"
      active-class="active"
      custom
    >
      <div
        :class="{ active: isActive }"
        class="item px-3 py-3 d-flex justify-content-between"
        @click="navigate"
      >
        <div class="">
          <h4 class="id mb-1"># {{ job.job_order_no | job-no }}</h4>
          <div class="house-number mb-1">
            {{ $t("feature.member.house_number") }} {{ job.address_no }}
          </div>
          <div class="detail">
            <strong>{{ job.request_items_count }}</strong>
            <span>{{ $t("feature.homecare.inform_list") }}</span>
            <strong v-show="job.job_order_items_count">{{
              job.job_order_items_count || "-"
            }}</strong>
            <span v-show="job.job_order_items_count">{{
              $t("feature.homecare.fixing_list")
            }}</span>
          </div>
        </div>
        <div class="text-end">
          <div class="date">{{ job.job_order_date | moment }}</div>
          <div
            :class="[job.job_order_status_code]"
            class="status homecare-status"
          >
            {{ $t("feature.homecare.status." + job.job_order_status_code) }}
          </div>
          <div class="">
            <div v-if="!job.is_read" class="badge">
              <span class="px-2 badge">N</span>
            </div>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    jobs: {
      type: Array,
      default: undefined,
    },
  },
}
</script>

<style lang="scss" scoped>
.item {
  border: solid 1px #f5f5f5;
  cursor: pointer;
  &:hover {
    background: #f9f9f9;
  }
  &.active {
    background: #efefef;
  }
  h4.id {
    margin: 0;
    font-size: 16px;
    font-weight: bold;
    color: #000000;
  }
  .house-number {
    font-size: 14px;
    font-weight: bold;
    color: #000000;
  }
  .detail {
    font-size: 14px;
    font-weight: 500;
    color: #4a4a4a;
  }
  .date {
    font-size: 14px;
    color: #8c8786;
  }
  .status {
    font-size: 16px;
    font-weight: bold;
  }
  .badge {
    font-size: 10px;
  }
}
</style>
